module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-Regular.9ca076be.woff2";